import { FieldInputProps, useField } from 'formik';
import React from 'react';

import Error from 'components/Error';

import Item from './Item';
import { Value, ItemType } from './interfaces';
import * as Styled from './styled';

/**
 * properties for the Radio button group
 */
export type ComponentProps = React.FieldsetHTMLAttributes<HTMLFieldSetElement> &
  Pick<FieldInputProps<Value>, 'name'> & {
    /**
     * The label for the radio button group
     */
    groupLabel?: string;
    /**
     * Collection of radio buttons to render
     */
    items: ItemType[];
    /**
     * Optional Label styled component props
     */
    errorLabelProps?: React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLLabelElement>,
      HTMLLabelElement
    >;
  };

export const RadioButton: React.FC<ComponentProps> = ({
  groupLabel,
  name,
  items,
  errorLabelProps,
  ...props
}) => {
  const [field, meta, helpers] = useField<Value>(name);
  const isError = !!(meta.touched && meta.error);

  return (
    <Styled.FieldsetWrapper {...props} aria-invalid={isError}>
      {groupLabel && <Styled.GroupLabel>{groupLabel}</Styled.GroupLabel>}
      <Styled.Wrapper>
        {items.map((item, i) => (
          <Item
            key={item.key || `${item.value}_${i}`}
            name={name}
            setValue={helpers.setValue}
            onChange={item.onChange}
            checked={item.value === field.value}
            disabled={item.disabled}
            value={item.value}
            label={item.label}
            subtitle={item.subtitle}
            inputProps={item.inputProps}
          />
        ))}
        {isError && <Error {...errorLabelProps}>{meta.error}</Error>}
      </Styled.Wrapper>
    </Styled.FieldsetWrapper>
  );
};

export default RadioButton;
